
import React from "react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Card, CardFooter } from "@/components/ui/card";

interface PricingSummaryProps {
  price: string;
  tshirtPrinting: boolean;
  printQuantity: number;
  handleSubmit: (e: React.FormEvent) => void;
}

const PricingSummary: React.FC<PricingSummaryProps> = ({
  price,
  tshirtPrinting,
  printQuantity,
  handleSubmit,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card>
        <CardFooter className="flex justify-between items-center">
          <div>
            <p className="text-sm text-gray-500">Estimated Total</p>
            <p className="text-2xl font-semibold text-madts-purple">${price}</p>
            {tshirtPrinting && printQuantity >= 4 && (
              <p className="text-xs text-green-600">Buy 3 Get the 4th Free discount applied!</p>
            )}
          </div>
          <Button
            className="bg-gradient-to-r from-madts-purple to-madts-pink hover:from-madts-purple/90 hover:to-madts-pink/90 text-white"
            size="lg"
            onClick={handleSubmit}
          >
            Submit Request
          </Button>
        </CardFooter>
      </Card>
    </motion.div>
  );
};

export default PricingSummary;
